var map = {
	"./get-it-on-google-play-badge-ar.svg": [
		34050,
		4050
	],
	"./get-it-on-google-play-badge-da.svg": [
		68306,
		8306
	],
	"./get-it-on-google-play-badge-de.svg": [
		79646,
		9646
	],
	"./get-it-on-google-play-badge-en.svg": [
		51218,
		1218
	],
	"./get-it-on-google-play-badge-es-mx.svg": [
		97001,
		7001
	],
	"./get-it-on-google-play-badge-es.svg": [
		31515,
		1515
	],
	"./get-it-on-google-play-badge-fr.svg": [
		77475,
		7475
	],
	"./get-it-on-google-play-badge-hi.svg": [
		95646,
		3265
	],
	"./get-it-on-google-play-badge-id.svg": [
		34888,
		4888
	],
	"./get-it-on-google-play-badge-it.svg": [
		29688,
		9688
	],
	"./get-it-on-google-play-badge-ja.svg": [
		53268,
		887
	],
	"./get-it-on-google-play-badge-ko.svg": [
		3421,
		3421
	],
	"./get-it-on-google-play-badge-nl.svg": [
		35273,
		5273
	],
	"./get-it-on-google-play-badge-no.svg": [
		62562,
		2562
	],
	"./get-it-on-google-play-badge-pl.svg": [
		83775,
		3775
	],
	"./get-it-on-google-play-badge-pt-br.svg": [
		63818,
		3818
	],
	"./get-it-on-google-play-badge-pt.svg": [
		17015,
		7015
	],
	"./get-it-on-google-play-badge-ru.svg": [
		65704,
		5704
	],
	"./get-it-on-google-play-badge-sv.svg": [
		3704,
		3704
	],
	"./get-it-on-google-play-badge-tr.svg": [
		76409,
		6409
	],
	"./get-it-on-google-play-badge-vi.svg": [
		90856,
		856
	],
	"./get-it-on-google-play-badge-zh-cn.svg": [
		26359,
		6359
	],
	"./get-it-on-google-play-badge-zh-hant.svg": [
		40695,
		695
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59177;
module.exports = webpackAsyncContext;